import { useState } from 'react';
import { updateServiceCommission } from '../../API/ProtectedAuth';
import { handleApiError } from '../../Utils/errorHandler';

export default function useUpdateServiceCommission(commissionId, { onSuccess } = {}) {
  const [values, setValues] = useState({
    commission: ''
  });
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    
    if (!values.commission) {
      newErrors.commission = 'نسبة العمولة مطلوبة';
    } else if (isNaN(values.commission) || parseFloat(values.commission) <= 0) {
      newErrors.commission = 'يجب إدخال رقم صحيح أكبر من صفر';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!validate()) return;

    setIsLoading(true);

    try {
      await updateServiceCommission(commissionId, {
        commission: parseFloat(values.commission)
      });
      setSuccess('تم تحديث نسبة العمولة بنجاح');
      setValues({ commission: '' });
      
      if (onSuccess) {
        setTimeout(() => {
          onSuccess();
        }, 1000);
      }
    } catch (err) {
      const errorMessage = handleApiError(err);
      setError(errorMessage);
      console.error('❌ خطأ في تحديث نسبة العمولة:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    values,
    errors,
    error,
    success,
    isLoading,
    handleChange,
    handleSubmit,
    setValues
  };
}
